<template>
  <div class="w-full" data-testid="top-games">
    <slot name="header">
      <h1
        v-if="displayHeader"
        class="flex items-center justify-center uppercase"
      >
        {{ t('landingpage/index/top_games') }}
      </h1>
    </slot>

    <card-slider>
      <div
        v-for="product in products"
        :key="product.id"
        class="h-[305px] w-[215px] shrink-0 snap-start 2xl:w-[18.75%]"
        data-testid="top-games-wrapper"
      >
        <games-slider-game-server-card :game="product" class="h-full w-full" />
      </div>
    </card-slider>
  </div>
</template>

<script setup lang="ts">
import type { StrapiProduct } from '~/apollo/types/types';

const { t } = useI18n();

withDefaults(
  defineProps<{
    displayHeader?: boolean;
    products: StrapiProduct[];
  }>(),
  {
    displayHeader: true,
  },
);
</script>
